import { colors } from '../../../theme/analyticsColors';

/**
 * Get a status color based on a numeric score.
 * Default thresholds: <40 = error, 40-69 = warning, >=70 = success
 */
export const getScoreColor = (
  value: number,
  thresholds = { low: 40, mid: 70 },
): string => {
  if (value >= thresholds.mid) return colors.success;
  if (value >= thresholds.low) return colors.warning;
  return colors.error;
};

/**
 * Get a status color for confidence values (0-1 scale).
 * <0.5 = error, 0.5-0.79 = warning, >=0.8 = success
 */
export const getConfidenceColor = (value: number): string =>
  getScoreColor(value * 100, { low: 50, mid: 80 });

/**
 * Get a status color for availability scores (0-100 scale).
 * <40 = error, 40-69 = warning, >=70 = success
 */
export const getAvailabilityColor = (value: number): string =>
  getScoreColor(value);

/**
 * Get a status color for readiness gauge (0-100 scale).
 * <50 = error, 50-79 = warning, >=80 = success
 */
export const getReadinessColor = (value: number): string =>
  getScoreColor(value, { low: 50, mid: 80 });
